import React, {useEffect, useState} from 'react'
import {IRoles, rolesInitValues as initialValues} from '../../models/RolesModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import Swal from 'sweetalert2'
import {useLocation, useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {PickList} from 'primereact/picklist'
import './styles.css'
import HeaderCard from '../../../../../../components/Forms/HeaderCard'
import {Input} from '../../../../../../components/Forms/Input'
import { Toolbar2 } from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import { PageTitle } from '../../../../../../_metronic/layout/core'
const API_URL = process.env.REACT_APP_API_URL || 'api'

const rolesSchema = Yup.object().shape({})

const FormRolesEdit: React.FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const {id, name} = location.state as any

  useEffect(() => {
    formik.setFieldValue('name', name)
    formik.setFieldValue('id', id)
    getPermissions(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const formik = useFormik<IRoles>({
    initialValues,
    validationSchema: rolesSchema,
    onSubmit: async (values) => {
      //validação permission
      if (values.permission) {
        let names: any = []
        values.permission.forEach((element: any) => {
          console.log('element', element)
          names.push(element.name)
        })
        values.permission = names
      }
      setLoading(true)
      try {
        await axios.put(API_URL + '/v1/roles/' + id, values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'ROLES.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/roles')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'ROLES.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })
        setLoading(false)
      }
    },
  })

  const [permissoes, setPermissoes] = useState([])
  const [selectedPermissoes, setSelectedPermissoes] = useState([])

  function resetInputs() {
    formik.resetForm()
    setSelectedPermissoes([])
  }

  async function getPermissions(id: any) {
    const target = await axios.get(API_URL + '/v1/roles/' + id)
    setSelectedPermissoes(target.data.data.permissions)

    const source = await axios.get(API_URL + '/v1/permissions/select2')

    const sourceFilter = source.data.results.filter((elem: any) => {
      return !target.data.data.permissions.some((element: any) => {
        return element.name === elem.name
      })
    })
    setPermissoes(sourceFilter)
  }

  const onChange = (event: any) => {
    setPermissoes(event.source)
    setSelectedPermissoes(event.target)
    formik.setFieldValue('permission', event.target)
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'ROLES.TITLE_EDIT'})}</PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='row mb-3'>
              <div className='col-lg-12'>
                <Input
                  title={intl.formatMessage({id: 'ROLES.TYPE_USER'})}
                  placeholder={intl.formatMessage({id: 'ROLES.TYPE_USER'})}
                  {...formik.getFieldProps('name')}
                  required
                />
              </div>
              {/* FIM NOME */}
            </div>
          </div>

          <PickList
            source={permissoes}
            target={selectedPermissoes}
            itemTemplate={(permissao: any) => (
              <div className='product-list-detail'>
                <h5 className='mb-2'>{permissao.name}</h5>
              </div>
            )}
            onChange={onChange}
            sourceHeader={intl.formatMessage({id: 'ROLES.PERMISSIONS_AVAILABLE'})}
            targetHeader={intl.formatMessage({id: 'ROLES.PERMISSIONS_SELECTED'})}
            sourceStyle={{height: '342px'}}
            targetStyle={{height: '342px'}}
            filterBy='name'
            sourceFilterPlaceholder={intl.formatMessage({id: 'ROLES.PERMISSIONS_SEARCH'})}
            targetFilterPlaceholder={intl.formatMessage({id: 'ROLES.PERMISSIONS_SEARCH'})}
          />

          <div className='d-flex justify-content-end py-6'>
            <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
              {!loading && intl.formatMessage({id: 'COMMON.EDIT_BUTTON'})}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  {intl.formatMessage({id: 'COMMON.EDITING_BUTTON'})}{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
            <button
              type='reset'
              onClick={resetInputs}
              className='btn btn-sm btn-secondary  mx-2
              '
            >
              {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
            </button>
          </div>
          {/* ----------------------------------------------------------------------------------- */}
        </form>
      </div>
    </div>
  )
}

export {FormRolesEdit}
